var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeStateAbsent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.411,
    height: 20.79,
    viewBox: "0 0 36.411 20.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;strokeWidth:0.581px;}.a,.c{stroke:#2e2310;}.b,.c{fill:none;strokeLinecap:square;strokeWidth:1.161px;fillRule:evenodd;}.b{stroke:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168.137 -113.921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,17.01V10H14v7.01H11L15,21l4-3.99ZM9,3,5,6.99H8V14h2V6.99h3Z",
    transform: "translate(185.549 113.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-white",
    transform: "translate(168.428 114.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,12.2V0",
    transform: "translate(182.74 119.898) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H12.2",
    transform: "translate(174.115 119.898) rotate(45)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStateAbsent);
export default __webpack_public_path__ + "static/media/changeStateAbsent.ba56404f934c6223cb6900b118d6fbad.svg";
export { ForwardRef as ReactComponent };